import { IconPropsType } from '..';

export const CallsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99999 0.900391H8.97758C5.01344 0.900391 1.79999 3.94944 1.79999 7.71076C1.79999 7.75581 1.80052 7.80087 1.80159 7.84592V7.83934V13.5026H5.39999V8.64932H3.59999C3.59999 8.0998 3.59742 8.03344 3.59732 7.69051C3.59732 5.22667 6.40329 2.70039 8.99999 2.70039H9.04747H9.0448H9.09015C11.6869 2.70039 14.4027 5.22667 14.4027 7.69051C14.4027 7.74265 14.4016 7.79479 14.4 7.84694V7.83934V8.64932H12.6V13.5026L14.4 13.5004C13.95 14.8504 11.6319 15.3004 8.99999 15.3004V17.1004C11.3406 17.1004 16.1989 17.1004 16.1989 12.6997V7.83985C16.2 7.80188 16.2 7.75683 16.2 7.71177C16.2 3.95045 12.9865 0.901403 9.0224 0.901403H8.99839H8.99945L8.99999 0.900391Z"
      fill="#23252A"
    />
  </svg>
);
